
import { Question } from '../types';

export const taj101CommonMistakesQuestions: Question[] = [
  {
    id: 'taj111',
    text: 'What type of mistake is it when a reciter changes a letter to another letter?',
    type: 'single',
    options: [
      { id: 'a', text: 'Laḥn jaliyy (clear error)', isCorrect: true },
      { id: 'b', text: 'Laḥn khafiyy (hidden error)', isCorrect: false },
      { id: 'c', text: 'Ghunnah', isCorrect: false },
      { id: 'd', text: 'Tashdīd', isCorrect: false }
    ],
    explanation: 'Changing a letter to another letter (e.g., reading ث as س) is considered laḥn jaliyy (a clear error). This is one of the four ways in which laḥn jaliyy can occur and is prohibited (ḥarām) if done deliberately.',
    topic: 'taj101'
  },
  {
    id: 'taj112',
    text: 'What is a common mistake when reciting letters with the ṣifah of qalqalah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Exaggerating the qalqalah sound', isCorrect: true },
      { id: 'b', text: 'Not pronouncing the qalqalah at all', isCorrect: false },
      { id: 'c', text: 'Adding a vowel before the qalqalah letter', isCorrect: false },
      { id: 'd', text: 'Changing the qalqalah letter to another letter', isCorrect: false }
    ],
    explanation: 'A common mistake when reciting letters with qalqalah (ق, ط, ب, ج, د) is exaggerating the qalqalah (disturbance/echo) sound, especially at the end of words. The qalqalah should be moderate and balanced.',
    topic: 'taj101'
  },
  {
    id: 'taj113',
    text: 'What mistake do reciters often make when pronouncing the letter ض (ḍād)?',
    type: 'single',
    options: [
      { id: 'a', text: 'Confusing it with ظ (ẓāʾ)', isCorrect: true },
      { id: 'b', text: 'Making it too light (tarqīq)', isCorrect: false },
      { id: 'c', text: 'Not applying iṭbāq', isCorrect: false },
      { id: 'd', text: 'Pronouncing it with a kasrah', isCorrect: false }
    ],
    explanation: 'A common mistake is confusing ض (ḍād) with ظ (ẓāʾ). The ض is pronounced from the side of the tongue touching the upper molars, while the ظ is pronounced from the tip of the tongue touching the edge of the upper central incisors.',
    topic: 'taj101'
  },
  {
    id: 'taj114',
    text: 'What is a common mistake when applying the rule of ikhfāʾ for nūn sākinah and tanwīn?',
    type: 'single',
    options: [
      { id: 'a', text: 'Pronouncing it as complete iṭh-hār (clear)', isCorrect: true },
      { id: 'b', text: 'Applying ghunnah for too long', isCorrect: false },
      { id: 'c', text: 'Converting it to a mīm', isCorrect: false },
      { id: 'd', text: 'Adding an extra vowel', isCorrect: false }
    ],
    explanation: 'A common mistake when applying ikhfāʾ for nūn sākinah and tanwīn is pronouncing it as complete iṭh-hār (making it clear) instead of hiding it. Ikhfāʾ is a state between iṭh-hār and idghām, where the nūn is neither fully pronounced nor fully assimilated.',
    topic: 'taj101'
  },
  {
    id: 'taj115',
    text: 'What is a common mistake when reciting مَالِكِ يَوْمِ الدِّينِ (māliki yawm id-dīn) from Sūrah al-Fātiḥah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Reading it as مَلِكِ (maliki) instead of مَالِكِ (māliki)', isCorrect: true },
      { id: 'b', text: 'Not applying idghām between مِ and ي', isCorrect: false },
      { id: 'c', text: 'Reading the lām in الدِّينِ with tafkhīm', isCorrect: false },
      { id: 'd', text: 'Not applying the madd in الدِّينِ', isCorrect: false }
    ],
    explanation: 'A common mistake when reciting مَالِكِ يَوْمِ الدِّينِ is reading it as مَلِكِ (maliki) instead of مَالِكِ (māliki), which changes the meaning from "Master" to "King". The alif in مَالِكِ must be pronounced with madd aṣlī (one alif in length).',
    topic: 'taj101'
  },
  {
    id: 'taj116',
    text: 'What mistake do reciters often make with the letter ع (ʿayn)?',
    type: 'single',
    options: [
      { id: 'a', text: 'Pronouncing it from the wrong place in the throat', isCorrect: true },
      { id: 'b', text: 'Giving it the quality of hams', isCorrect: false },
      { id: 'c', text: 'Reading it with tafkhīm', isCorrect: false },
      { id: 'd', text: 'Adding a tashdīd to it', isCorrect: false }
    ],
    explanation: 'A common mistake with ع (ʿayn) is pronouncing it from the wrong place in the throat. The ʿayn should be pronounced from the middle throat, but many reciters incorrectly pronounce it from the upper throat or even from the back of the tongue.',
    topic: 'taj101'
  },
  {
    id: 'taj117',
    text: 'What mistake is commonly made when applying the rule of madd muttaṣil?',
    type: 'single',
    options: [
      { id: 'a', text: 'Not extending it to the required length (3-4 alifs)', isCorrect: true },
      { id: 'b', text: 'Extending it too much (beyond 5 alifs)', isCorrect: false },
      { id: 'c', text: 'Adding a ghunnah sound to it', isCorrect: false },
      { id: 'd', text: 'Pronouncing the hamzah as an ʿayn', isCorrect: false }
    ],
    explanation: 'A common mistake with madd muttaṣil is not extending it to the required length of 3-4 alifs (tawassuṭ). This often happens when reciters rush their recitation and don\'t give the madd its due length.',
    topic: 'taj101'
  },
  {
    id: 'taj118',
    text: 'What is a common mistake when reciting letters with the ṣifah of istiʿlāʾ?',
    type: 'single',
    options: [
      { id: 'a', text: 'Not applying tafkhīm (full-mouth pronunciation)', isCorrect: true },
      { id: 'b', text: 'Applying too much tafkhīm', isCorrect: false },
      { id: 'c', text: 'Adding a qalqalah sound', isCorrect: false },
      { id: 'd', text: 'Changing the letter\'s makhraj', isCorrect: false }
    ],
    explanation: 'A common mistake when reciting letters with istiʿlāʾ (خُصَّ ضَغْطٍ قِظْ) is not applying tafkhīm (full-mouth pronunciation). These letters require the back part of the tongue to rise toward the palate, giving them a fuller sound.',
    topic: 'taj101'
  },
  {
    id: 'taj119',
    text: 'What mistake do reciters often make when applying the rule of iqlāb?',
    type: 'single',
    options: [
      { id: 'a', text: 'Not fully changing the nūn sākinah to a mīm', isCorrect: true },
      { id: 'b', text: 'Changing it to a letter other than mīm', isCorrect: false },
      { id: 'c', text: 'Not applying ghunnah with the mīm', isCorrect: false },
      { id: 'd', text: 'Applying iqlāb with letters other than bāʾ', isCorrect: false }
    ],
    explanation: 'A common mistake in applying iqlāb is not fully changing the nūn sākinah to a mīm when it is followed by a bāʾ. The nūn should completely transform into a mīm (without a visible mīm in writing), pronounced with ghunnah (nasal sound).',
    topic: 'taj101'
  },
  {
    id: 'taj120',
    text: 'What is a common mistake when reciting the word اللَّه (Allah) after a kasrah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Pronouncing the lām with tafkhīm instead of tarqīq', isCorrect: true },
      { id: 'b', text: 'Pronouncing the lām with tarqīq instead of tafkhīm', isCorrect: false },
      { id: 'c', text: 'Not pronouncing the shadda on the lām', isCorrect: false },
      { id: 'd', text: 'Elongating the final hāʾ', isCorrect: false }
    ],
    explanation: 'A common mistake when reciting اللَّه (Allah) after a kasrah (as in بِسْمِ اللَّهِ) is pronouncing the lām with tafkhīm instead of tarqīq. When preceded by a kasrah, the lām in Allah should be pronounced with tarqīq (thin/empty-mouth pronunciation).',
    topic: 'taj101'
  }
];
